module.exports = __webpack_public_path__ + "img/safari.62f5681f.svg";